import { render, staticRenderFns } from "./AssignmentsActions.vue?vue&type=template&id=32693e93&scoped=true&"
import script from "./AssignmentsActions.vue?vue&type=script&lang=js&"
export * from "./AssignmentsActions.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsActions.vue?vue&type=style&index=0&id=32693e93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32693e93",
  null
  
)

export default component.exports